import { render, staticRenderFns } from "./FormMultiSelect.vue?vue&type=template&id=13d072ce"
import script from "./FormMultiSelect.vue?vue&type=script&lang=js"
export * from "./FormMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports